import { ref } from 'vue-demi'
/**
 *@description table相关的hook
 */
export function useTable() {
  const scroll = ref({})
  /**
   * @description 计算滚动的高度
   */
  const getScroll = tableDom => {
    // table的高度
    const tableHeight = tableDom.offsetHeight
    const theadHeight = tableDom.getElementsByTagName('thead')[0].offsetHeight
    scroll.value = { y: tableHeight - theadHeight }
    console.log('scroll11111', scroll)
  }
  return {
    scroll,
    getScroll
  }
}